(function () {
  'use strict';

  function initMobileHeader() {
    var header = document.querySelector('[data-makeen-mobile-header]');
    var trigger = document.querySelector('[data-makeen-mobile-menu-trigger]');
    var drawer = document.querySelector('[data-makeen-mobile-drawer]');
    var overlay = document.querySelector('[data-makeen-mobile-menu-overlay]');
    var closeButton = drawer ? drawer.querySelector('.js-eveland-close') : null;
    var cartCount = header ? header.querySelector('[data-makeen-mobile-cart-count]') : null;

    if (!header || !trigger || !drawer || !overlay) return;

    function setExpanded(isExpanded) {
      trigger.setAttribute('aria-expanded', String(isExpanded));
      trigger.setAttribute('aria-label', isExpanded ? 'Menü schließen' : 'Menü öffnen');
      drawer.setAttribute('aria-hidden', String(!isExpanded));
    }

    function syncExpandedState() {
      window.requestAnimationFrame(function () {
        setExpanded(drawer.classList.contains('active'));
      });
    }

    function closeDrawer() {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      trigger.classList.remove('active');
      document.body.classList.remove('activemenu_mobile');
      setExpanded(false);
      trigger.focus();
    }

    function syncCartCount() {
      if (!cartCount) return;

      var quantity = parseInt(cartCount.textContent, 10) || 0;
      cartCount.hidden = quantity < 1;
      var cartLink = cartCount.closest('a');

      if (cartLink) {
        cartLink.setAttribute('aria-label', quantity > 0 ? 'Warenkorb öffnen, ' + quantity + ' Artikel' : 'Warenkorb öffnen');
      }
    }

    trigger.addEventListener('click', syncExpandedState);
    overlay.addEventListener('click', syncExpandedState);

    if (closeButton) {
      closeButton.addEventListener('click', syncExpandedState);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('active')) {
        closeDrawer();
      }
    });

    if (cartCount && window.MutationObserver) {
      new MutationObserver(syncCartCount).observe(cartCount, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    setExpanded(false);
    syncCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileHeader);
  } else {
    initMobileHeader();
  }
}());
